import React from "react";
import DestinoCuadro from "./DestinoCuadro";
import Slider from "react-slick";
import carouselSettings from "../carouselSettings";
import HotelCuadro from "../../Hoteles/Home/HotelCuadro";
import arrowLeft from "../../../imagenes/paquetes/ribbon/arrowLeft.png";
import arrowRight from "../../../imagenes/paquetes/ribbon/arrowRight.png";

const DestinoFila = (props) => {
  const { origen, destino, fecha, titulo, productos, onAdultosChange } = props;
  /*
    this.state = {
      slideIndex: 0,
      updateCount: 0,
    };
  */
  const handleAdultosChange = (cantidad) => {
    onAdultosChange(cantidad);
  };

  let settings = carouselSettings[2];
  settings.infinite = true;
  settings.nextArrow = <SampleNextArrow />;
  settings.prevArrow = <SamplePrevArrow />;
  //settings.slidesToShow = 4;
  if (settings.slidesToShow >= productos.length && productos.length !== 0) {
    settings.infinite = false;
    //settings.slidesToShow = 3;
  }

  return (
    <section className="destinos">
      <div className="container">
        {/*--TITULO--*/}
        <div className="row title">
          <div className="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
            <hr />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <h3>{titulo}</h3>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
            <hr />
          </div>
        </div>
        {/*--SLIDER--*/}
        <div className="carousel-destinos">
          <Slider ref={(slider) => (this.slider = slider)} {...settings}>
            {productos.map((producto) => {
              return (
                <div key={producto.idProducto}>
                  {origen !== "CDR" && (
                    <DestinoCuadro
                      producto={producto}
                      origen={origen}
                      destino={destino}
                      fecha={fecha}
                      onAdultosChange={handleAdultosChange}
                    />
                  )}
                  {origen === "CDR" && (
                    <HotelCuadro
                      producto={producto}
                      origen={origen}
                      destino={destino}
                      fecha={fecha}
                    />
                  )}
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </section>
  );
};

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <img
      className={className}
      onClick={onClick}
      src={arrowRight}
      alt="Siguiente"
    />
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <img
      className={className}
      onClick={onClick}
      src={arrowLeft}
      alt="Anterior"
    />
  );
}

export default DestinoFila;



// WEBPACK FOOTER //
// ./src/components/Home/DestinoFila/index.js